import React from 'react';
import Header from '../components/Header';
import ZaHackathon from '../components/ZaHackathon';
import Footer from '../components/Footer';

function AboutPage() {
  return (
    <>
      <Header />
      <div className="pt-16 md:pt-20">
        <ZaHackathon />
      </div>
      <Footer />
    </>
  );
}

export default AboutPage;
